import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import ProposalDashboard from "containers/Proposal/Dashboard";
import ProposalListView from "containers/Proposal/List";
import { useColumnHeaders, useFacetedSearch } from "hooks";
import { setProposalSearchBar } from "store/actions/proposals";
import { proposalListSelectors } from "store/selectors";
import { COLUMN_HEADER_KEYS, DEFAULT_PROPOSAL_COLUMN_HEADERS } from "globals/constants";
import styles from "./styles.css";


const ProposalMainView = () => {
	const PROPOSAL_LIST_ID = "proposalsTable";

	const PROPOSAL_LIST_DEFAULT_COLUMNS = [
		DEFAULT_PROPOSAL_COLUMN_HEADERS.PROJECT_TITLE,
		DEFAULT_PROPOSAL_COLUMN_HEADERS.PROPOSAL_NUMBER,
		DEFAULT_PROPOSAL_COLUMN_HEADERS.PI,
		DEFAULT_PROPOSAL_COLUMN_HEADERS.STATUS,
		DEFAULT_PROPOSAL_COLUMN_HEADERS.SPONSOR,
		DEFAULT_PROPOSAL_COLUMN_HEADERS.PRIME_SPONSOR,
		DEFAULT_PROPOSAL_COLUMN_HEADERS.ADMIN_UNIT,
		DEFAULT_PROPOSAL_COLUMN_HEADERS.PROJECT_START_DATE,
		DEFAULT_PROPOSAL_COLUMN_HEADERS.PROJECT_END_DATE,
		DEFAULT_PROPOSAL_COLUMN_HEADERS.PROPOSAL_TYPE,
		DEFAULT_PROPOSAL_COLUMN_HEADERS.INSTRUMENT_TYPE
	];

	const { columnHeaders: availableColumns, defaultColumnHeaders, dashboardColumnHeaders } =
        useColumnHeaders(COLUMN_HEADER_KEYS.PROPOSAL, {
			defaultColumnHeaders: PROPOSAL_LIST_DEFAULT_COLUMNS
        });

	const { searchFacets, onSearchChange } = useFacetedSearch({
		availableColumns: dashboardColumnHeaders,
		setSearchFragments: setProposalSearchBar,
	});

	const { search } = useSelector(proposalListSelectors.content);
	const [ actualFacets, setActualFacets ] = useState({});


	useEffect(()=>{
		const reduxSearch = { ...search };
		const selectedFacets = {};
		Object.keys(reduxSearch).forEach((searchKey) => {
			const facet = searchFacets.find((facet) => facet.searchKey === searchKey);
			if (facet) {
				selectedFacets[facet.key] = reduxSearch[searchKey];
			}
		});
		setActualFacets(selectedFacets);
	}, [ search, searchFacets ]);

	return (
		<div id="view-main-proposal" className={styles.viewMainProposal}>
			<ProposalDashboard dashboardTilesAriaControls={PROPOSAL_LIST_ID} searchFacets={searchFacets}
				onSearchChange={onSearchChange} actualFacets={actualFacets}
			/>
			<ProposalListView proposalListId={PROPOSAL_LIST_ID}
				searchFacets={searchFacets} onSearchChange={onSearchChange} availableColumns={availableColumns}
				defaultColumnHeaders={defaultColumnHeaders} actualFacets={actualFacets}
			/>
		</div>
	);
};

export default ProposalMainView;
